import classes from "./SeedLister.module.css"
import Control from "./Salmonrun/Control"
import ResultSet from "./Salmonrun/ResultSet"
import { useEffect, useState } from "react"
import { defaultSchedule, defaultSRGear } from "../../DefaultEntries"
import { useLocalStorage, decrypted_key, SkillIDsRev } from "../../Utils"
import XORSHIFT128 from "./RNGLib"
import CoopReward from "../../assets/json/parameters/spl__CoopRewardConfig.spl__CoopRewardConfig.json"
import MurmurHash3 from "murmurhash3js"
import { next } from "../SeedChecker/SeedCalculator"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMartiniGlassEmpty } from "@fortawesome/free-solid-svg-icons"

const RewardCapsules = {
    Money: <img src={"https://leanny.github.io/splat3/images/capsules/CapsuleIcon_00.png"} alt={"Money"} width={48} />,
    Food: <img src={"https://leanny.github.io/splat3/images/capsules/CapsuleIcon_01.png"} alt={"Food"} width={48} />,
    Drink: <img src={"https://leanny.github.io/splat3/images/capsules/CapsuleIcon_02.png"} alt={"Drink"} width={48} />,
    GearSkillChip: <img src={"https://leanny.github.io/splat3/images/capsules/CapsuleIcon_03.png"} alt={"GearSkillChip"} width={48} />,
    GearRandom: <img src={"https://leanny.github.io/splat3/images/capsules/CapsuleIcon_04.png"} alt={"GearRandom"} width={48} />,
    GearMonthly: "",
}

const Salmonrun = props => {
    const [scheduleData, setScheduleData] = useLocalStorage("schedule", defaultSchedule)
    const [SRGearData, setSRGearData] = useLocalStorage("SRGear", defaultSRGear)

    const format_date_string = val => {
        return val.split(":")[0].replace("T", "").replaceAll("-", "")
    }

    const [currentStartTime, setCurrentStartTime] = useState(format_date_string(new Date().toISOString()))
    const [currentSchedule, setCurrentSchedule] = useState([])
    const [onlyScales, setonlyScales] = useState(false)
    const [currentNumberOfFrames, setCurrentNumberOfFrames] = useState(24)
    const [prefix, setPrefix] = useState("Coop")
    const [results, setResults] = useState([])
    const { t } = useTranslation()

    const convert_reward = res => {
        let resElem
        for (let k in CoopReward.CapsuleInside) {
            const elem = CoopReward.CapsuleInside[k]
            if (elem.CapsuleRarity === res.RewardRarity && elem.CapsuleType === res.RewardType) {
                resElem = elem
                break
            }
        }
        if (!resElem) {
            const r = [<img key={res.CapsuleType} src={res.RewardImage} alt={res.CapsuleType} width={48} />]
            let rand = next(res.Random)
            r.push(
                <img
                    src={`https://leanny.github.io/splat3/images/skill/${SkillIDsRev[rand % 28 >>> 1]}.png`}
                    width={48}
                    alt={SkillIDsRev[rand % 28 >>> 1]}
                    className={classes.Ability}
                    key={rand}
                />
            )
            for (let i = 2; i <= res.RewardRarityNum; i++) {
                rand = next(rand)
                r.push(
                    <img
                        src={`https://leanny.github.io/splat3/images/skill/${SkillIDsRev[rand % 28 >>> 1]}.png`}
                        width={32}
                        alt={SkillIDsRev[rand % 28 >>> 1]}
                        className={classes.Ability}
                        key={rand}
                    />
                )
            }
            return r
        }

        if (resElem.IsMoney) {
            return (
                <>
                    <img src={"https://leanny.github.io/splat3/images/misc/GiftMoneyIcon_00.png"} width={48} alt={resElem.Value} />
                    {resElem.Value}
                </>
            )
        }
        if (resElem.CapsuleType === "Drink") {
            let drinks = []
            let r = res.Random
            for (let i = 0; i < resElem.Value; i++) {
                r = next(r)
                drinks.push(
                    <img
                        src={`https://leanny.github.io/splat3/images/skill/${SkillIDsRev[r % 14]}.png`}
                        width={48}
                        alt={SkillIDsRev[r % 14]}
                        className={classes.Ability}
                        key={r}
                    />
                )
            }
            return (
                <>
                    <FontAwesomeIcon icon={faMartiniGlassEmpty} /> {drinks}
                </>
            )
        }
        if (resElem.CapsuleType === "Food") {
            let desc
            if (resElem.Ticket === "Money50") {
                desc = (
                    <>
                        <img src={"https://leanny.github.io/splat3/images/food/IconShopFood.png"} alt={resElem.Ticket} width={48} /> (+ 50%)
                    </>
                )
            }
            if (resElem.Ticket === "Money100") {
                desc = (
                    <>
                        <img src={"https://leanny.github.io/splat3/images/food/IconShopFoodL.png"} alt={resElem.Ticket} width={48} /> (+
                        100%)
                    </>
                )
            }
            if (resElem.Ticket === "MoneyParty") {
                desc = <img src={"https://leanny.github.io/splat3/images/food/IconShopParty_02.png"} alt={resElem.Ticket} width={48} />
            }
            return (
                <>
                    {resElem.Value} x {desc}
                </>
            )
        }
        if (resElem.CapsuleType === "GearSkillChip") {
            const chip = SkillIDsRev[next(res.Random) % 14]
            return (
                <>
                    {resElem.Value} x{" "}
                    <img
                        src={`https://leanny.github.io/splat3/images/skill/${chip}.png`}
                        width={48}
                        alt={chip}
                        className={classes.Ability}
                    />{" "}
                    ({t("translation:LayoutMsg.Cmn_Menu_00.T_Count_01")})
                </>
            )
        }
        if (resElem.CapsuleType === "UrokoSilver") {
            return (
                <>
                    {resElem.Value} x{" "}
                    <img src={`https://leanny.github.io/splat3/images/coop/UrocoIcon_01.png`} width={48} alt={"Silver Scales"} />
                </>
            )
        }
        if (resElem.CapsuleType === "UrokoGold") {
            return (
                <>
                    {resElem.Value} x{" "}
                    <img src={`https://leanny.github.io/splat3/images/coop/UrocoIcon_00.png`} width={48} alt={"Gold Scales"} />
                </>
            )
        }
        if (resElem.CapsuleType === "UrokoRandom") {
            switch (resElem.CapsuleRarity) {
                case "VeryRare":
                    return (
                        <>
                            {resElem.Value} x{" "}
                            <img src={`https://leanny.github.io/splat3/images/coop/UrocoIcon_00.png`} width={48} alt={"Gold Scales"} />
                        </>
                    )
                case "Rare":
                    return (
                        <>
                            {resElem.Value} x{" "}
                            <img src={`https://leanny.github.io/splat3/images/coop/UrocoIcon_01.png`} width={48} alt={"Gold Scales"} />
                        </>
                    )
                case "Common":
                    return (
                        <>
                            {resElem.Value} x{" "}
                            <img src={`https://leanny.github.io/splat3/images/coop/UrocoIcon_02.png`} width={48} alt={"Gold Scales"} />
                        </>
                    )
                default:
                    return <></>
            }
        }
        return ""
    }

    const checkNumberOfFrameHandler = event => {
        let inputstr = event.target.value
        inputstr = inputstr.replace(/[^0-9]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0 || inputstr === "0") {
            inputstr = "1"
        }
        inputstr = inputstr.substring(0, 3) // cut off too many characters
        setCurrentNumberOfFrames(inputstr)
    }
    const checkScalesHandler = event => {
        setonlyScales(currentValue => !currentValue)
        calculateResults(!onlyScales)
    }

    const startTimeHandler = event => {
        if (event.target.value >= 0) {
            const elem = currentSchedule[event.target.value]
            setCurrentStartTime(format_date_string(elem.startTime))
            setPrefix(elem.type)
        }
    }

    const get_xorshift = () => {
        return new XORSHIFT128(
            MurmurHash3.x86.hash32(`${prefix}_0_${decrypted_key()}_${currentStartTime}`) >>> 0,
            MurmurHash3.x86.hash32(`${prefix}_1_${decrypted_key()}_${currentStartTime}`) >>> 0,
            MurmurHash3.x86.hash32(`${prefix}_2_${decrypted_key()}_${currentStartTime}`) >>> 0,
            MurmurHash3.x86.hash32(`${prefix}_3_${decrypted_key()}_${currentStartTime}`) >>> 0
        )
    }

    const calculatePoints = () => {
        if (prefix === "Coop") {
            const points = [...CoopReward.RewardMeterNomal.ElementArray]
            for (const elem of CoopReward.RewardMeterNomal.RepearElementArray) {
                if (elem.RepeatNum > 0) {
                    for (let i = 0; i < elem.RepeatNum; i++) {
                        points.push({
                            KumaScale: elem.StartKumaScale + i * elem.KumaScaleSpan,
                            RewardMeterElementType: elem.RewardMeterElementType,
                        })
                    }
                } else {
                    for (let i = 0; i < 487; i++) {
                        points.push({
                            KumaScale: elem.StartKumaScale + i * elem.KumaScaleSpan,
                            RewardMeterElementType: elem.RewardMeterElementType,
                        })
                    }
                }
            }

            return points.sort((a, b) => a.KumaScale - b.KumaScale)
        } else if (prefix === "CoopBigRun") {
            const points = [...CoopReward.RewardMeterBigRun.ElementArray]
            for (const elem of CoopReward.RewardMeterBigRun.RepearElementArray) {
                if (elem.RepeatNum > 0) {
                    for (let i = 0; i < elem.RepeatNum; i++) {
                        points.push({
                            KumaScale: elem.StartKumaScale + i * elem.KumaScaleSpan,
                            RewardMeterElementType: elem.RewardMeterElementType,
                        })
                    }
                } else {
                    for (let i = 0; i < 487; i++) {
                        points.push({
                            KumaScale: elem.StartKumaScale + i * elem.KumaScaleSpan,
                            RewardMeterElementType: elem.RewardMeterElementType,
                        })
                    }
                }
            }
            return points.sort((a, b) => a.KumaScale - b.KumaScale)
        } else {
            const points = [...CoopReward.RewardMeterLimited.ElementArray]
            for (const elem of CoopReward.RewardMeterLimited.RepearElementArray) {
                if (elem.RepeatNum > 0) {
                    for (let i = 0; i < elem.RepeatNum; i++) {
                        points.push({
                            KumaScale: elem.StartKumaScale + i * elem.KumaScaleSpan,
                            RewardMeterElementType: elem.RewardMeterElementType,
                        })
                    }
                } else {
                    for (let i = 0; i < 487; i++) {
                        points.push({
                            KumaScale: elem.StartKumaScale + i * elem.KumaScaleSpan,
                            RewardMeterElementType: elem.RewardMeterElementType,
                        })
                    }
                }
            }
            return points.sort((a, b) => a.KumaScale - b.KumaScale)
        }
    }

    const evaluate = res => {
        return (
            <div className={classes.FlexElem2} key={res.Idx}>
                {RewardCapsules[res.RewardType]} {convert_reward(res)}
            </div>
        )
    }

    const calculateResults = updatedScales => {
        const RewardTypes = [
            "None",
            "Unknown",
            "Money",
            "Food",
            "Drink",
            "GearSkillChip",
            "GearRandom",
            "GearMonthly",
            "UrokoSilver",
            "UrokoGold",
            "UrokoRandom",
        ]
        const RewardRarities = ["None", "Unknown", "Common", "Rare", "VeryRare", "SuperRare"]
        const RewardTypeProbability = RewardTypes.map(e => CoopReward.RandomWeight[e] || 0)
        const rng = get_xorshift()
        const int_seed = rng.get_u32()
        const res = []
        const pointsRequired = calculatePoints()
        let rotation_data
        for (const k of Object.keys(SRGearData).sort((a, b) => a > b)) {
            if (rotation_data === undefined || format_date_string(k) <= currentStartTime) {
                rotation_data = SRGearData[k]
            }
        }
        const current_gear = rotation_data.current
        for (let i = 0; i < parseInt(currentNumberOfFrames); i++) {
            const seed = new XORSHIFT128(((int_seed * pointsRequired[i].KumaScale) & 0xffffffff) >>> 0, 0)
            let cumProb = 0
            let RewardType = 0
            let RewardRarity = 0
            let RewardImage
            if (pointsRequired[i].RewardMeterElementType === "MonthlyGear") {
                RewardType = 7
                RewardImage = current_gear
            } else if (pointsRequired[i].RewardMeterElementType === "UsedGearCapsule") {
                RewardType = 6
            } else if (pointsRequired[i].RewardMeterElementType === "UrokoSilver") {
                RewardType = 8
            } else if (pointsRequired[i].RewardMeterElementType === "UrokoGold") {
                RewardType = 9
            } else if (pointsRequired[i].RewardMeterElementType === "UrokoRandom") {
                RewardType = 10
            } else {
                for (let k = 0; k < RewardTypes.length; k++) {
                    if (RewardTypeProbability[k] > 0) {
                        cumProb += RewardTypeProbability[k]
                        const x = seed.get_rand_int(0, cumProb)
                        if (RewardTypeProbability[k] > x) {
                            RewardType = k
                        }
                    }
                }
            }
            if (RewardType === 6) {
                let res = 0
                for (let i = 0; i < rotation_data.past.length; i++) {
                    if (seed.get_rand_int(0, i + 1) === 0) {
                        res = i
                    }
                }
                RewardImage = rotation_data.past[res]
            }

            if (pointsRequired[i].RewardMeterElementType === "RandomHit") {
                RewardRarity = 4
            } else {
                const RarityWeight = RewardRarities.map(e => CoopReward.RarityWeight[RewardTypes[RewardType]].Weight[e])
                cumProb = 0
                for (let k = 0; k < RewardRarities.length; k++) {
                    if (RarityWeight[k] > 0) {
                        cumProb += RarityWeight[k]
                        const x = seed.get_rand_int(0, cumProb)
                        if (RarityWeight[k] > x) {
                            RewardRarity = k
                        }
                    }
                }
            }

            if (!updatedScales || RewardType === 8 || RewardType === 9 || RewardType === 10) {
                res.push({
                    Idx: pointsRequired[i].KumaScale * 100,
                    Result: evaluate({
                        RewardType: RewardTypes[RewardType],
                        RewardRarity: RewardRarities[RewardRarity],
                        Random: seed.get_u32(),
                        RewardRarityNum: RewardRarity,
                        RewardImage: RewardImage,
                        Idx: pointsRequired[i].KumaScale * 100,
                    }),
                    key: pointsRequired[i].KumaScale * 100,
                })
            }
        }
        setResults(res)
    }

    useEffect(() => {
        const setTime = schedules => {
            const all_times = []
            for (let data of schedules.regularSchedules.nodes) {
                all_times.push({ ...data, type: "Coop" })
            }
            for (let data of schedules.bigRunSchedules.nodes) {
                all_times.push({ ...data, type: "CoopBigRun" })
            }
            for (let data of schedules.teamContestSchedules.nodes) {
                all_times.push({ ...data, type: "CoopTeamContest" })
            }
            const sorted_by_time = all_times.sort(e => e.startTime)
            setCurrentSchedule(sorted_by_time)
            setCurrentStartTime(format_date_string(sorted_by_time[0].startTime))
            setPrefix(sorted_by_time[0].type)
        }

        const s1 = scheduleData.data.coopGroupingSchedule.regularSchedules.nodes[0] ?? {
            endTime: new Date(2099, 1, 1).toISOString(),
            temp: true,
        }
        const s2 = scheduleData.data.coopGroupingSchedule.bigRunSchedules.nodes[0] ?? {
            endTime: new Date(2099, 1, 1).toISOString(),
            temp: true,
        }
        const s3 = scheduleData.data.coopGroupingSchedule.teamContestSchedules.nodes[0] ?? {
            endTime: new Date(2099, 1, 1).toISOString(),
            temp: true,
        }
        const min_time = [s1, s2, s3].sort(k => k.endTime)[0]
        if (min_time.temp || new Date(s1.endTime) <= Date.now()) {
            fetch("https://splatoon3.ink/data/schedules.json")
                .then(response => response.json())
                .then(response => {
                    setScheduleData(response)
                    setTime(response.data.coopGroupingSchedule)
                })
        } else {
            setTime(scheduleData.data.coopGroupingSchedule)
        }
    }, [setScheduleData, scheduleData, setCurrentStartTime])

    useEffect(() => {
        fetch("https://leanny.github.io/splat3/sr_gear.json")
            .then(response => response.json())
            .then(response => {
                setSRGearData(response)
            })
    }, [setSRGearData])
    return (
        <>
            <Control
                scheduleData={currentSchedule}
                selectChange={startTimeHandler}
                selectValue={currentStartTime}
                inputChange={checkNumberOfFrameHandler}
                inputValue={currentNumberOfFrames}
                scalesChange={checkScalesHandler}
                scalesValue={onlyScales}
                calculateResults={calculateResults}
                format_date_string={format_date_string}
            />
            {<ResultSet results={results} />}
        </>
    )
}

export default Salmonrun
